import React, { useCallback, useEffect } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import PopOver from '@prisjakt/ui-popover';
import { IUnfeaturedColumns } from '../../types';
import PriceRowStoreInfoColumn from '../shared/store-info-column';
import * as S from '../styles';
// import AlternativesIndicator from './alternatives-indicator';
import StockPriceInfo from '../../components/stock-price-info';
import { GoToStoreButton } from '../../components/go-to-store-button';

export const UnfeaturedColumns: React.FC<IUnfeaturedColumns> = props => {
  const {
    tableLinkProps,
    // alternativePrices,
    campaign,
    priceDisplay,
    name,
    price,
    priceId,
    priceType,
    stock,
    store,
    rating,
    priceRowRef,
    showDisabledInfo,
    setShowDisabledInfo,
  } = props;
  const { t } = useAppContext();

  const featured = Boolean(store?.featured);

  const handleOutSideClick = useCallback(
    e => {
      if (
        priceRowRef &&
        priceRowRef.current &&
        priceRowRef.current.contains(e.target)
      ) {
        return;
      }
      setShowDisabledInfo(false);
    },
    [priceRowRef, setShowDisabledInfo]
  );

  // componentWillUnmount
  useEffect(() => {
    return () => {
      window.removeEventListener('click', handleOutSideClick);
    };
  }, [handleOutSideClick]);

  // Callback for showDisabledInfo state change
  useEffect(() => {
    if (showDisabledInfo) {
      window.addEventListener('click', handleOutSideClick);
    } else {
      window.removeEventListener('click', handleOutSideClick);
    }
  }, [handleOutSideClick, showDisabledInfo]);

  return (
    <>
      <S.Link {...tableLinkProps}>
        <PriceRowStoreInfoColumn store={store} rating={rating} />
        <S.MiddleColumn>
          <S.TopMiddleRow featured={featured}>
            <S.ProductNameColumn featured={featured}>
              <S.ProductName featured={featured}>{name}</S.ProductName>
              {/* <S.Column>
                <AlternativesIndicator
                  featured={featured}
                  alternativePrices={alternativePrices}
                />
              </S.Column> */}
            </S.ProductNameColumn>
            <StockPriceInfo
              featured={featured}
              campaign={campaign}
              price={price}
              priceDisplay={priceDisplay}
              priceType={priceType}
              stock={stock}
              isMemberPrice={false}
            />
          </S.TopMiddleRow>
        </S.MiddleColumn>
      </S.Link>
      <PopOver
        id={`click-out-${priceId}`}
        open={Boolean(showDisabledInfo)}
        width={250}
        offsetY={-54}
        offsetX={0}
        arrowOffsetY={0}
        position="left"
        label={t('product', 'transparency.prices-more-info-button')}
        onClose={() => setShowDisabledInfo(!showDisabledInfo)}
      >
        <S.Link {...tableLinkProps}>
          <S.EndColumn featured={featured}>
            <GoToStoreButton />
          </S.EndColumn>
        </S.Link>
        <S.TransparencyShopInfo>
          {t('product', 'transparency.store-info')}
        </S.TransparencyShopInfo>
      </PopOver>
    </>
  );
};
